export default {
  containerClass: "container px-4 xl:px-2 mx-auto",
  bgDarkClass: "bg-violet-950",
  borderLClass: "border-violet-300",
  borderMClass: "border-violet-500",
  borderDClass: "border-violet-700",
  textMClass: "text-violet-500",
  btnClass:
    "inline-flex justify-center items-center px-4 lg:px-8 py-2 lg:py-3 rounded-3xl bg-violet-700 text-white hover:bg-violet-800 overflow-hidden text-ellipsis whitespace-nowrap",
  btnClass2:
    "inline-flex justify-center items-center px-4 lg:px-8 py-2 lg:py-3 rounded-lg text-sm bg-violet-700 text-white hover:bg-violet-800 overflow-hidden text-ellipsis whitespace-nowrap",
  hoverClass: "hover:text-violet-400",
  inputClass: "px-4 py-2 w-full rounded-lg bg-transparent",
  textareaClas:
    "px-4 py-2 w-full rounded-lg bg-transparent overflow-y-auto overflow-x-hidden min-h-[120px]",
};
